module.exports = __webpack_public_path__ + "media/post-listing-block-5-image.b843cbbb.webp";